<template>
    <div style="display: flex; box-shadow: 0px 3px 10px #53829833; background: #fff">
    <div class="manin-panel">
        <el-row>
            <h3 class="main-title" style="text-align: left;">choose the item you want</h3>
        </el-row>
        <el-row style="justify-content: space-between;">
            <el-col :span="10" :xs="24" :sm="24" :md="24" :lg="11" :xl="11"
            class="card-col">
                <div class="card-box">
                    <div class="card-tile"><strong class="card-box-bold-title">Platform 1.0</strong></div>
                    <div class="card-content">manage your agent/company/user</div>
                    <div style="display: flex;">
                    <div class="card-button">
                        <el-button @click="goToPage('Platform')" text link style="color:#fff;font-size:1rem;">global-ptt
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    <div class="card-button" style="background: #909399;">
                        <el-button @click="goToPage('GenericPlatform')" text link style="color:#fff;font-size:1rem;" type="info">generic
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    </div>

                    <div class="card-img">
                        <el-image :src="require('@/assets/cardpng/w1.png')" :max-scale="0.8"></el-image>
                    </div>
                    <div class="card-buttons-mobile">
                        <el-button type="primary" text
                        @click="goTomenu('Platform')"
                        class="mobile-button">global-ptt
                        </el-button>
                        <el-button
                        type="info"
                        text
                        class="mobile-button-grey"
                        @click="goTomenu('GenericPlatform')"
                        >
                         generic
                        </el-button>
                    </div>
                </div>

            </el-col>
            <el-col :span="10" :xs="24" :sm="24" :md="24" :lg="11" :xl="11"
            class="card-col">
                <div class="card-box">
                    <div class="card-tile" ><strong class="card-box-bold-title">Platform 2.0</strong></div>
                    <div class="card-content">New platform to manage your agent/company/user</div>
                    <div style="display: flex;">
                    <div class="card-button">
                        <el-button @click="goToPage('PlatformV2')" text link style="color:#fff;font-size:1rem;">global-ptt
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    <div class="card-button" style="background: #909399;">
                        <el-button @click="goToPage('GenericPlatformV2')" text link style="color:#fff;font-size:1rem;" type="info">generic
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    </div>

                    <div class="card-img">
                        <el-image :src="require('@/assets/cardpng/w2.png')" :max-scale="0.8"></el-image>
                    </div>
                    <div class="card-buttons-mobile">
                        <el-button type="primary" text
                        @click="goTomenu('PlatformV2')"
                        class="mobile-button">global-ptt
                        </el-button>
                        <el-button
                        type="info"
                        text
                        class="mobile-button-grey"
                        @click="goTomenu('GenericPlatformV2')"
                        >
                         generic
                        </el-button>
                    </div>
                </div>

            </el-col>
            <el-col :span="10"  :xs="24" :sm="24" :md="24" :lg="11" :xl="11"
            class="card-col">
                <div class="card-box">
                    <div class="card-tile"><strong>Dispatch</strong></div>
                    <div class="card-content">login dispatcher account to query the position of the members and SOS, etc</div>
                    <div style="display: flex;">
                    <div class="card-button">
                        <el-button @click="goToPage('Dispatch')" text link style="color:#fff;font-size:1rem;">
                            global-ptt
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    <div class="card-button" style="background: #909399;">
                        <el-button @click="goToPage('GenericDispatch')" text link style="color:#fff;font-size:1rem;">
                            generic
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    </div>
                    <div class="card-img">
                        <el-image :src="require('@/assets/cardpng/w3.png')" :max-scale="0.8"></el-image>
                    </div>
                    <div class="card-buttons-mobile">
                        <el-button type="primary" text class="mobile-button"
                        @click="showDialog(dispatchUrls.globalptt)">global-ptt
                        </el-button>
                        <el-button
                        type="info"
                        text
                        class="mobile-button-grey"
                        @click="showDialog(dispatchUrls.generic)"
                        >generic</el-button>
                    </div>
                </div>

            </el-col>
            <el-col :span="10"  :xs="24" :sm="24" :md="24" :lg="11" :xl="11"
            class="card-col">
                <div class="card-box">
                    <div class="card-tile"><strong>APP</strong></div>
                    <div class="card-content">Initiate a group conversation with your team members using an Android or iOS app</div>
                    <div style="display: flex;">
                    <div class="card-button">
                        <el-button @click="goToPage('iOS')" text link style="color:#fff;font-size:1rem;">
                            iOS
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    <div class="card-button" style="background: #909399;">
                        <el-button @click="goToPage('Android')" text link style="color:#fff;font-size:1rem;">
                            Android
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    </div>
                    <div class="card-img">
                        <el-image :src="require('@/assets/cardpng/w4.png')" :max-scale="0.8"></el-image>
                    </div>
                    <div class="card-buttons-mobile">
                        <el-button type="primary" text class="mobile-button"
                        @click="goToPage('iOS')">iOS
                        </el-button>
                        <el-button
                        type="info"
                        text
                        class="mobile-button-grey"
                        @click="goToPage('Android')"
                        >Android</el-button>
                    </div>
                </div>

            </el-col>
            <el-col :span="10" :xs="24" :sm="24" :md="24" :lg="11" :xl="11"
            class="card-col">
                <div class="card-box">
                    <div class="card-tile"><strong>Radios</strong></div>
                    <div class="card-content">global-ptt self-produced products</div>
                    <div style="display: flex;">
                    <div class="card-button" @click="goTomenu('Radios')">
                         <el-button @click="goToPage('Radios')" text link style="color:#fff;font-size:1rem;">gloabl-ptt
                        <el-icon class="el-icon--right"><Right /></el-icon>
                         </el-button>
                    </div>
                    <div class="card-button" style="background: #909399;">
                         <el-button @click="waitToDevelop()" text link style="color:#fff;font-size:1rem;">generic
                        <el-icon class="el-icon--right"><Right /></el-icon>
                         </el-button>
                    </div>
                    </div>
                    <div class="card-img">
                        <el-image :src="require('@/assets/cardpng/w5.png')" :max-scale="0.8"></el-image>
                    </div>
                    <div class="card-buttons-mobile">
                        <el-button type="primary"  text
                        class="mobile-button"
                        @click="goTomenu('Radios')">global-ptt
                        </el-button>
                        <el-button
                        type="info"
                        text
                        class="mobile-button-grey"
                        @click="waitToDevelop()"
                        >generic</el-button>
                    </div>
                </div>

            </el-col>
            <el-col :span="10" :xs="24" :sm="24" :md="24" :lg="11" :xl="11"
            class="card-col">
                <div class="card-box">
                    <div class="card-tile"><strong>Sims</strong></div>
                    <div class="card-content">query or renew your global-ptt sim cards</div>
                    <div style="display: flex;">
                    <div class="card-button">
                        <el-button @click="goToPage('Sims')" text link style="color:#fff;font-size:1rem;">global-ptt
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    <div class="card-button" style="background: #909399;">
                        <el-button @click="goToPage('GenericIot')" text link style="color:#fff;font-size:1rem;">generic
                            <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                    </div>
                    </div>
                    <div class="card-img">
                        <el-image :src="require('@/assets/cardpng/w6.png')" :max-scale="0.8"></el-image>
                    </div>
                    <div  class="card-buttons-mobile">
                        <el-button type="primary"  text
                        class="mobile-button"
                        @click="goTomenu('Sims')">global-ptt
                        </el-button>
                    <el-button
                        type="info"
                        text
                        class="mobile-button-grey"
                        @click="goToPage('GenericIot')"
                        >generic</el-button>
                    </div>
                </div>

            </el-col>
        </el-row>

    </div>
    <!-- 弹窗组件 -->
    <el-dialog
      v-model="dialogVisible"
      title="Tips"
      width="60%"
      :before-close="handleClose"
    >
      <span>{{ dialogMessage }}</span>
      <template #footer>
        <el-button @click="dialogVisible = false">Close</el-button>
      </template>
    </el-dialog>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Right} from '@element-plus/icons-vue'
import { goTomenu, getPageDesc } from '@/utils/storeUtils'
import { ElMessage } from 'element-plus'

const goToPage = (pageName) => {
    goTomenu(pageName)
}

const waitToDevelop = () => {
    ElMessage({
    message: 'The system is scheduled for development at present',
    type: 'success',
  })
}

// 控制弹窗显示/隐藏的状态
const dialogVisible = ref(false);

// 弹窗提示信息
const dialogMessage = ref('');

const dispatchUrls = {
    globalptt: "https://dispatch.global-ptt.com/",
    generic: "https://dispatch.ltd"
}

// 显示弹窗的函数
const showDialog = (param) => {
  dialogMessage.value = `Please browse it on a computer`;
  dialogVisible.value = true;
};

// 关闭弹窗的处理函数
const handleClose = (done) => {
  dialogVisible.value = false;
  done();
};


</script>

<style scoped>
.manin-panel {
    width: 77%;
    position: relative;
    left: 11.4%;
    right: 11.4%;
}
.flex-grow {
  flex-grow: 1;
}
.main-title {
    text-align: left;
}
.card-box{
    background-image: url('@/assets/card-bg.png');
    background-size: cover;
    font-size: 1.2rem;
    justify-content: start;
    border-radius: 129px 31px 132px 31px;
    border: 2px solid #1D88FE;
    width: 696px;
    height: 564px;
}
.card-tile {
    width: 131px;
    height: 45px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 1.6rem;
    color: #333333;
    line-height: 38px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin: 79px 0px 0px 12%;
}
.card-content{
    width: 388px;
    height: 68px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    font-size: 1.2rem;
    text-align: left;
    margin: 10px 0px 0px 12%;
}
.card-button {
    margin: 24px 24px;
    width: 50%;
    height: 61px;
    background: #00A4FF;
    border-radius: 9px 9px 9px 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 1rem;
}
.el-button {
    --el-button-active-bg-color: : #FFC107;
}
.card-img {
    padding: 0px 25px 0px 30px;
    max-width: 600px;
}
.card-col {
    height: 596px;
    margin-right: 20px;
    display: flex;
    margin-bottom: 20px;
    justify-content: center;
}
.card-buttons-mobile {
    display: none
}
.title {
  font-family: 'CustomFont', sans-serif;
  font-weight: bold; /* 会自动匹配 myfont-bold.otf */
}

.body-text {
  font-family: 'CustomFont', sans-serif; /* 默认使用 myfont.ttf */
}
.card-box-bold-title {
    width: 190px;
    display: block;
}
/* 在小屏幕上修改样式 */
@media screen and (max-width: 550px) {
  .main-title {
    font-size: 1.5rem;
  }
  .manin-panel{
    width: 88%;
    left: 6%;
    right: 6%;
  }
  .card-col{
    height: 290px;
  }
  .card-box{
    background: url('@/assets/card-bg1.png') no-repeat top center;
    background-size: cover;
    border-radius: 51px 22px 58px 22px;
    border: 2px solid #1D88FE;
    height: 290px;
    width: 100%;
  }
  .card-button{
    display: none;
  }
  .card-img {
    margin-top: 10px;
    padding: 0px 10px 0px 10px
   }
  .mobile-button {
    position: relative;
    width: 80px;
    height: 32px;
    border: 1px solid #00A4FF;
    border-radius: 10px;
    background: #fff;
    margin-right: 12px;
  }
  .card-button-mobile-grey {
    display: flex;
    position: relative;
    width: 80px;
    height: 32px;
    border-radius: 10px;
    background:grey;
    }
  .mobile-button-grey {
    background-color: grey;
    color: white;
    width: 80px;
    height: 32px;
    border-radius: 10px;
    padding: 0; /* 移除内边距 */
    margin: 0; /* 移除外边距 */
    }
  .card-buttons-mobile {
    display: flex;
    position: relative;
    top: 12px;
    left: 42%;
  }
  .card-content{
    margin: 9px 0px 0px 32px;
    font-size: 14px;
    height: 40px;
    width: 275px;
    line-height: 16px;
  }
  .card-tile {
    margin: 25px 0px 0px 32px;
    font-size: 1rem;
    font-weight: 500;
    height: 20px;
  }

}
</style>